import Icon from '../components/Icon.vue'

Icon.register({
  'wine-glass-alt': {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M216 464H176V346.8C244.5 330.9 294.1 266.9 287.4 192.7L271.4 14.6C270.7 6.3 263.9 0 255.7 0H32.3C24.1 0 17.3 6.3 16.6 14.6L0.6 192.7C-6 266.9 43.5 330.9 112 346.8V464H72C49.9 464 32 481.9 32 504 32 508.4 35.6 512 40 512H248C252.4 512 256 508.4 256 504 256 481.9 238.1 464 216 464zM61.8 48H226.3L233.4 128H54.6L61.8 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wine-glass-alt.js
// module id = s1Fk
// module chunks = 144